(function () {
    'use strict';

    angular.module('swif.patrimoine')
    .component('patrimoinePropertiesTable', {
        templateUrl: 'partials/patrimoine/property_table.html',
        controller: PropertiesController,
        bindings: {
            propertiesOf: '<'
        }
    });



    function PropertiesController($scope, $location, swif, patrimoine) {
        'ngInject';
        var service = patrimoine.property;

        console.log('init PatrimoinePropertyController');
        $scope.referentiel = patrimoine.referentiel.data.referentiel;
        $scope.debug = swif.debug;
        $scope.STATES = patrimoine.STATES_OBJ;
        $scope.newModel = {};
        $scope.addAction = swif.action.getActionById('patrimoine_property', 'list', 'add');
        $scope.copyInto = {};
        $scope.filters = {
            category: service.getCategoryFilter()
        };

        $scope.callback = callback;
        $scope.preModal = preModal;
        $scope.preValidate = preValidate;
        $scope.onCategorySelected = onCategorySelected;
        $scope.importAction = importAction;
        $scope.$watch('copyInto.referentiel', watchReferentiel);
        $scope.$watch('newModel.category_id', watchCategoryId);
        $scope.$watch('referentiel.currentItem', watchCurrentItem);

        fetchCategories();
        fetchCollection();

        function callback(error, data) {
            if (error) {
                return;
            }
            var model, action;
            function _callback(error, data) {
                swif.collections.defaultCallbackMessage(error, data);
            }
            if (data.action.id === 'add_intervention_request') {
                model = {
                    name: swif.i18n.getString('Replace') + ' ' + data.model.name,
                    site1: data.model.site_id,
                    equipment_id: data.model.equipment_id,
                    patrimoine_property_ids: [data.model.id]
                };
                action = swif.action.getActionById(
                    'intervention_request',
                    'list', 'add'
                );
                swif.action.dispatch(
                    'intervention_request', action, model,
                    {callback: _callback}
                );
            } else if (data.action.id === 'add_intervention') {
                model = {
                    name: swif.i18n.getString('Replace') + ' ' + data.model.name,
                    site1: data.model.site_id,
                    equipment_id: data.model.equipment_id,
                    patrimoine_property_ids: [data.model.id]
                };
                action = swif.action.getActionById(
                    'intervention',
                    'list', 'add'
                );
                swif.action.dispatch(
                    'intervention', action, model,
                    {callback: _callback}
                );
            } else {
                $scope.patrimoine_properties.callback(error, data);
            }
        }
        function preModal(data) {
            if ($scope.patrimoine_properties) {
                $scope.patrimoine_properties.preModal(data);
            }
        }
        function preValidate(data) {
            if (_.isArray(data.model.state) && !_.isEmpty(data.model.state)) {
                data.model.state = data.model.state[0];
            }
            if ($scope.patrimoine_properties) {
                $scope.patrimoine_properties.preValidate(data);
            }
            return true;
        }
        // retrieve categories presents on the patrimoine properties
        // in order to display a shortcut for 'category_id' filter
        function fetchCategories() {
            var filter = computeFilter();
            service.getExistingCategories(filter).then(function (categories) {
                $scope.categories = categories;
            });
        }

        function onCategorySelected(item) {
            item._selected = !item._selected;
            updateCollection();
        }


        function watchCategoryId(newV) {
            if (newV) {
                var current = getCurrent();
                if (current._type === 'patrimoine_site') {
                    $scope.newModel.site_id = [current.id, current.name];
                } else {
                    $scope.newModel.equipment_id = [current.id, current.name];
                }
                $scope.newModel.state = 'good';
                swif.action.dispatch(
                    'patrimoine_property',
                    $scope.addAction,
                    angular.copy($scope.newModel),
                    {
                        preValidate: $scope.preValidate,
                        callback: $scope.callback
                    }
                );
                delete $scope.newModel.category_id;
            }
        }
        function watchCurrentItem(newV) {
            if (newV && $scope.patrimoine_properties) {
                updateCollection();
                fetchCategories();
            }
        }

        function watchReferentiel(newV) {
            if (newV) {
                //property_ids one2many
                var contentType = getCurrent()._type;
                var ofields = [
                    'site_id',
                    'equipment_id',
                    'category_id',
                    'name',
                    'qty',
                    'state',
                    'consumable_id',
                    'price',
                    'date_purchase',
                    'date_start',
                    'life_duration',
                    'date_end'
                ];
                var fields = [
                    'site_id/.id',
                    'equipment_id/.id',
                    'category_id/.id',
                    'name',
                    'qty',
                    'state',
                    'consumable_id/.id',
                    'price',
                    'date_purchase',
                    'date_start',
                    'life_duration',
                    'date_end'
                ];
                var items = angular.copy($scope.patrimoine_properties.items);
                var data = swif.data.prepareImport(items, ofields);
                //sanitize many2one
                _.forEach(data, function (item) {
                    if (item[0]) {
                        if (contentType === 'patrimoine_site') {
                            item[0] = newV[0];
                        } else {
                            item[0] = false;
                        }
                    }
                    if (item[1]) {
                        if (contentType === 'patrimoine_equipment') {
                            item[1] = newV[0];
                        } else {
                            item[1] = false;
                        }
                    }
                    if (item[2]) {
                        item[2] = item[2][0];
                    }
                    if (item[6]) {
                        item[6] = item[6][0];
                    }
                });
                return swif.data.callKw('patrimoine_property', 'import_data', [
                    fields, data
                ]).then(function () {
                    swif.message.addInfo('data imported successfully');
                    $scope.patrimoine_properties.getItems();
                    delete $scope.copyInto.referentiel;
                });
            }
        }

        function getCurrent() {
            return $scope.referentiel.currentItem;
        }

        // @addCategoriesFilter: (boolean) defines the use (or not)
        // of selected categories to compute the filter
        function computeFilter(addCategoriesFilter) {
            var current = getCurrent();
            var categories = _.filter($scope.categories, '_selected');
            return service.getFilter(current, addCategoriesFilter, categories);
        }

        function fetchCollection() {
            var filter = computeFilter(true);
            swif.collections.createOrUpdate(
                'patrimoine_properties',
                'patrimoine_property',
                filter
            ).then(function(collection) {
                $scope.patrimoine_properties = collection;
            });
        }

        // createOrUpdate() seems to double-fetch collection when updating it.
        // pb seems to be that currentFilter is watched (to refetch data),
        // and createOrUpdatre both update currentFilter and refetch data,
        // it could explain why data are fetch twice.
        // until a fix is applied, i use another method to updatem y
        function updateCollection() {
            var filter = computeFilter(true);
            $scope.patrimoine_properties.currentFilter = filter;
        }

        function importAction() {
            var action = swif.action.getActionById('patrimoine_property', 'list', 'import');
            if (action) {
                swif.action.dispatch(
                    'patrimoine_property',
                    action,
                    $scope.referentiel.currentItem, {
                        preValidate: $scope.preValidate,
                        callback: $scope.callback
                    }
                );
            }
        }

    }


})();
